import React from 'react';
import { StyledNumbersCol } from './StyledNumbersCol';

const NumbersCol = ({ children, isImage }) => {
  return (
    <React.Fragment>
      {
        <StyledNumbersCol isImage={isImage}>
          {children}
        </StyledNumbersCol>
          
      }
    </React.Fragment>
  );
};

export default NumbersCol;
